import PageShell from "@/components/PageShell";
import Hero from "@/components/Hero";
import TrustStrip from "@/components/TrustStrip";
import Marquee from "@/components/Marquee";
import Problem from "@/components/Problem";
import SolutionOverview from "@/components/SolutionOverview";
import Solution from "@/components/Solution";
import ProductCards from "@/components/ProductCards";
import PatentFiled from "@/components/PatentFiled";
import FinalCTA from "@/components/FinalCTA";

export default function Home() {
    return (
        <PageShell testid="landing-page">
            <Hero />
            <TrustStrip />
            <Marquee />
            <Problem />
            <SolutionOverview />
            <Solution />
            <ProductCards />
            <PatentFiled />
            <FinalCTA />
        </PageShell>
    );
}
